<app-menu-crud-panel-bot [rows]="recordRowsLogs" [conf]="recordConfBtns" [toggle]="layoutAsToggle">
	<app-chart-vape-progression-day PanelContent></app-chart-vape-progression-day>
</app-menu-crud-panel-bot>